import Reflux from "reflux";
import fetch from "logic/rest/FetchProvider";
import URLUtils from "util/URLUtils";
import MongoDBDataAdapterEntry from "../models/MongoDBDataAdapterEntry";
export const MongoDBDataAdapterActions = Reflux.createActions({
  create: { asyncResult: true },
  update: { asyncResult: true },
  delete: { asyncResult: true },
  search: { asyncResult: true },
  stats: { asyncResult: true }
});
const URL = "/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/";
export const MongoDBDataAdapterStore = Reflux.createStore({
  listenables: [MongoDBDataAdapterActions],
  data: {
    entries: [],
    pagination: {
      total: 0,
      count: 0,
      page: 0,
      perPage: 0
    }
  },
  statsData: null,
  adapterUrl(path) {
    const effectivePath = path ? `${URL}${path}` : URL;
    return URLUtils.qualifyUrl(effectivePath);
  },
  getInitialState() {
    return { data: this.data, statsData: this.statsData };
  },
  create(entry) {
    const promise = fetch("POST", this.adapterUrl(entry.dataAdapterId), entry.toJSON());
    MongoDBDataAdapterActions.create.promise(promise);
  },
  update(entry) {
    const promise = fetch("PUT", this.adapterUrl(`${entry.dataAdapterId}/${entry.id}`), entry.toJSON());
    MongoDBDataAdapterActions.update.promise(promise);
  },
  search(dataAdapterId, query, page, perPage) {
    const promise = fetch(
      "GET",
      URLUtils.qualifyUrl(`${URL}/${dataAdapterId}?query=${query}&page=${page}&per_page=${perPage}`)
    );
    promise.then((response) => {
      const entries = response.entries.map((entry) => MongoDBDataAdapterEntry.fromJSON(entry));
      this.data = {
        pagination: {
          total: response.total,
          page: response.page,
          perPage: response.per_page,
          count: response.count
        },
        entries
      };
      this.trigger({ data: this.data });
      return response;
    });
    MongoDBDataAdapterActions.search.promise(promise);
  },
  delete(entry) {
    const promise = fetch("DELETE", this.adapterUrl(`${entry.dataAdapterId}/${entry.id}`));
    MongoDBDataAdapterActions.delete.promise(promise);
  },
  stats(adapterId) {
    const promise = fetch("GET", this.adapterUrl(`stats/${adapterId}`));
    promise.then((response) => {
      this.statsData = {
        entriesCount: response.entries_count
      };
      this.trigger({ statsData: this.statsData });
    });
    MongoDBDataAdapterActions.stats.promise(promise);
  }
});
